import { AitHeaderCellData, newHeaderCell } from "aic";

/**
 * Ensure header cells are present and normalised.
 * This will return a single default header cell when none are provided. When
 * existing cells are supplied it will ensure required identifiers and defaults
 * are set and will use provided columnIds where available.
 *
 * @param defaultCellWidth - Default width to apply to cells
 * @param blank - Blank value used when creating a default cell
 * @param columnIds - Optional list of column ids to assign when creating cells
 * @param cs - Optional existing header cells to normalise
 * @returns An array of normalised AitHeaderCellData
 */
export const headerCellPreProcess = <T>(
  defaultCellWidth: number,
  blank: T,
  columnIds: string[],
  cs?: AitHeaderCellData<T>[],
): AitHeaderCellData<T>[] => {
  if (cs === undefined) {
    const columnId = columnIds && columnIds.length > 0 ? columnIds[0] : crypto.randomUUID();
    return [newHeaderCell(defaultCellWidth, blank, columnId)];
  }

  // Check aitid and columnId and ensure defaults where necessary
  return cs.map((c, index) => {
    // Use provided columnId if available, otherwise use existing columnId
    const columnId = columnIds && columnIds.length > index ? columnIds[index] : c.columnId;
    return {
      aitid: c.aitid && c.aitid.length > 4 ? c.aitid : crypto.randomUUID(),
      text: c.text,
      justifyText: c.justifyText,
      comments: c.comments,
      colWidth: c.colWidth ?? defaultCellWidth,
      textIndents: c.textIndents,
      replacedText: undefined,
      repeatRowSpan: undefined,
      spaceAfterRepeat: undefined,
      spaceAfterSpan: undefined,
      colSpan: c.colSpan ?? 1,
      rowSpan: c.rowSpan ?? 1,
      repeatColSpan: undefined,
      coreTrafficLight: c.coreTrafficLight,
      templateAitId: c.templateAitId,
      templateColumnAitId: c.templateColumnAitId,
      columnId,
    };
  });
};
